<script>
    import { fade } from 'svelte/transition';
    import { push } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import fetchData from '../../api.js';
    import UserStore from '../../stores/user';
    import { cartsStore }  from '../../stores/cartStore';
    import fetchCarts from '../../agents.js';
    import { _ } from "svelte-i18n";

    import Header from '../../components/Header.svelte'; 
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 

    export let params;

    let isLoading = false;
    let carts = {};
    let selectedCartId = null;

    async function deleteCart(cartId) {
        if (!confirm($_('agents.cart.confirm_delete') || 'Delete this cart?')) return;
        isLoading = true;
        let postData = {
            action: 'agents_delete_cart',
            token: $UserStore.data,
            cart_id: cartId
        }
        let response = await fetchCarts(postData);
        if (response && response.success) {
            delete carts[cartId];
            cartsStore.set(carts);
        } else {
            alert($_('agents.cart.delete_failed') || 'Failed to delete cart');
        }
        isLoading = false;
    }



    onMount(async () => {
        if (!$UserStore || !$UserStore.data) {
            push('/login');
            return;
        }

        let postData = {
            action : 'agents_get_carts',
            token : $UserStore.data
        }
        let response = await fetchCarts(postData);
        carts = response?.data || {};


    });




</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading} />
    <Header />

    <div class="page">
        <TopInfo />

        <div class="shipment">

            <h2 class="mb-2 font-bold">{$_('agents.cart.title')}</h2>
            
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

                {#each Object.keys(carts) as cartId}
                    <div
                        class="p-3 border mb-2 rounded cursor-pointer relative"
                        class:bg-gray-200={selectedCartId == cartId}
                        on:click={() => push(`/agents/carts/${cartId}`)}
                    >
                        <div class="font-semibold">
                            {carts[cartId].customer_name || $_('agents.cart.no_customer')}
                        </div>

                        <div class="text-sm text-gray-500">
                            {carts[cartId].date_time}
                        </div>

                        <button
                            class="text-sm text-red-600 hover:underline mt-2"
                            on:click|stopPropagation={() => deleteCart(cartId)}
                        >
                            {$_('agents.cart.delete') || 'Delete'}
                        </button>

                    </div>
                {/each}   
       

            </div>

        </div>
    </div>
</div>

<style>
    .search-box {
        margin: 15px 0;
    }

    input[type="text"] {
        width: 300px;
        padding: 8px;
        border: 1px solid #ddd;
    }



    .product-name {
        font-weight: bold;
        margin-bottom: 10px;
    }

    .variants {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .variant-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px;
        background: #fafafa;
    }

    .variant-info {
        display: flex;
        flex-direction: column;
    }

    .variant-name {
        font-size: 14px;
    }

    .variant-sku,
    .variant-price {
        font-size: 12px;
        color: #666;
    }

    .variant-actions {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    input[type="number"] {
        width: 60px;
        padding: 4px;
    }


    .border {
        border: 1px solid #efefef;
    }
</style>
